import React, { useEffect, useRef } from 'react';

const SCROLL_MARGIN = '5rem';

const Anchor = ({ id }) => {
  const markerRef = useRef(null);

  useEffect(() => {
    const target = markerRef.current?.nextElementSibling;
    if (!id || !target) return;

    target.id = id;
    target.style.scrollMarginTop = SCROLL_MARGIN;
  }, [id]);

  return (
    <span
      ref={markerRef}
      aria-hidden="true"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    />
  );
};

export default Anchor;
